import './UpcomingAppointmentsComponent.scss';
import CardComponent from "../../../shared/components/card/CardComponent";
import CalendarDateCardComponent from "../../../shared/components/calendar-date-card/CalendarDateCardComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../shared/services";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import ListInfoCardComponent from "../../../shared/components/list-info-card/ListInfoCardComponent";
import {ImageConfig} from "../../../constants";
import moment from "moment";
import StatusCardComponent from "../../../shared/components/status-card/StatusCardComponent";

interface UpcomingAppointmentsComponentProps {

}

const UpcomingAppointmentsComponent = (props: UpcomingAppointmentsComponentProps) => {

    const [data, setData] = useState({});
    const [appointmentsList, setAppointments] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchData = useCallback((date: string) => {
        console.log(date, 'date');
        const startDate = moment(date);
        const endDate = startDate.clone().add(6, 'days');

        console.log('endDate', endDate.format('YYYY-MM-DD'));

        const payload = {
            start_date: startDate.format('YYYY-MM-DD'),
            end_date: endDate.format('YYYY-MM-DD'),
        };

        CommonService._dashboard.GetAllSevenDaysAppointments(payload)
            .then((response) => {
                setData(response.data);
            });

    }, [setData]);

    useEffect(() => {
        fetchData(moment().format('YYYY-MM-DD'));
    }, [fetchData]);


    const getAppointmentListData = useCallback((date: string) => {
        setIsLoading(true);
        const payload = {
            start_date: date,
            end_date: date,
        }
        CommonService._dashboard.GetAllAppointments(payload)
            .then((response) => {
                setIsLoading(false);
                setAppointments(response.data.docs);
            }).catch((error) => {
            console.log(error)
            setIsLoading(false);
            setAppointments([]);
        })

    }, []);

    return (
        <div className="upcoming-appointment-component">
            <CardComponent>
                <div className={'up-comingAppointment__details__header'}>
                    <div className={'up-comingAppointment__details__header__title'}>
                        Upcoming Appointments
                    </div>
                    <LinkComponent route={CommonService._routeConfig.AppointmentList()}>
                        Show More
                    </LinkComponent>
                </div>
                <CalendarDateCardComponent appointments={data} onDateChange={getAppointmentListData}/>
                {
                    isLoading &&
                    <div className={'status-wrapper d-flex justify-content-center align-items-center mt-5'}>
                        <LoaderComponent size={'sm'} type={'spinner'}/>
                    </div>
                }
                {
                    !isLoading && <div className={'up-comingAppointment__details__appointment'}>
                        {
                            appointmentsList?.length > 0 && appointmentsList?.map((appointment: any, index: number) => {
                                return (
                                    <div key={index} className={'mrg-bottom-10'}>
                                        <ListInfoCardComponent value={appointment?.service_details?.name}
                                                               backgroundColor={'#FFFFFF'}
                                                               imageUrl={'https://images.unsplash.com/photo-1741070487520-907d1359cb95?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'}
                                                               subDescription={<div className={'wrapper'}>
                                                                   <div className={'mrg-right-5'}>
                                                                       <ImageConfig.DashboardClockIcon/></div>
                                                                   <div>{CommonService.getHoursAndMinutesFromMinutes(appointment?.start_time)} | {appointment?.duration} mins</div>
                                                               </div>}
                                                               description={
                                                                   <>{appointment?.provider_details?.first_name + " " + appointment?.provider_details?.last_name}</>
                                                               }/>
                                    </div>
                                )

                            })
                        }
                        {
                            appointmentsList?.length === 0 &&
                            <div className={'status-wrapper'}>
                                <StatusCardComponent title={'No upcoming appointments.'}/>
                            </div>
                        }
                    </div>
                }


            </CardComponent>

        </div>
    )
}
export default UpcomingAppointmentsComponent;
